export default __webpack_public_path__ + "static/viz/media/splunk.77f66f62.svg";